


import TiwiMixin from '../mixins/TiwiMixin'

export default {
  mixins: [ TiwiMixin ],
  props: {
    relatedId: {
      required: true,
      //type: Number,
    },
    relatedType: {
      //type: Number,
      required: false,
      default: 'post'
    },
    score: {
      //type: Number,
      required: false,
      default: 0
    },
    votes: {
      required: false,
      default: 0
    },
    disableRating: {
      type: Boolean,
      required: false,
      default: false,
    }
    
  },
  data() {
		return {
      active: false,
      current_score: null,
      current_votes: 0,
		}
	},
  mounted: function() {
		// Eseguito al mount
    this.active = false;
    this.current_score = this.score;
    this.current_votes = this.votes;

	},
  computed: {

  },
  methods: {
    handleVote: function( vote ){

      var self = this;

      if( this.disableRating )
        return;

      self.setLoading(true);

      var data =  { vote: this.vote };

      var post_data = { type: 'VOTE', related_id: this.relatedId, related_type: this.relatedType, data };


      this.api.post('user-event/dispatch', post_data )
        .then( (response) => {

          if( response.data.success ){

          }
          else{
            self.toast.error( response.data.message );

          }

        })
        .catch( (error) => {
          self.toast.error( 'Errore nella richiesta' );
        })
        .finally( () => self.setLoading(false) )
    },

    checkRating: function( current ){

      if(this.current_score === null) return false;
      return current <= this.current_score;

    },
  },
}
